import { FC, memo } from "react";
import { ResponsiveCellProps } from "./Table.interface";

const ResponsiveCell : FC<ResponsiveCellProps> = ({label, value}) => {
    return <><span className="table-cell-label hide-for-desktop">{label}:</span><span>{value}</span></>
}

export default memo(ResponsiveCell);